module.exports = __webpack_public_path__ + "img/rt-min.281b1385.svg";